import React, { useState, useRef, useEffect, useCallback } from 'react';
import CustomTabPanel from './CustomTabPanel.jsx'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  FormControl,
  InputLabel,
  Box,
  Button,
  Radio,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  TextField,
  LinearProgress,
  Typography,
  TextareaAutosize,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Tabs,
  Tab,
  AppBar,
  Toolbar,
  Autocomplete,
  RadioGroup,
  FormLabel
} from "@mui/material";
import CustomMenuList from './CustomMenuList.jsx';
import NumberField from './NumberField.jsx';
import ComboBox from './ComboBox.jsx';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import {TIRedTheme} from './TIRedTheme.jsx'
import DOMPurify from 'dompurify';
import axios from "axios";
import { Provider, useDispatch, connect } from 'react-redux';
import { configureStore, createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ConnectedLineChart from "./ConnectedLineChart.jsx";









const App = () => {
    /* eslint-disable-next-line no-undef */
    const _bakedUrl = (typeof __BRIDGE_URL__ !== 'undefined' ? __BRIDGE_URL__ : '').trim();
    const _paramUrl = new URLSearchParams(window.location.search).get('bridgeUrl') || '';
    const serverUrl = (_paramUrl || _bakedUrl).trim().replace(/\/$/, '');


    

    
        
    const [value_tw1, setValue_tw1] = React.useState(0); 
    const handleChange_tw1 = (event, newValue) => { setValue_tw1(newValue); };
    
        
    
        
    
        
    
        
            

    

    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    



    




    

    
        
    

    
        
    



    

    
        
    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    



    




    

    
        
    

    
        
    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    



    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    



    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    



    




    



    


        
    
        
            

    

    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    



    




    



    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    



    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    



    




    



    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    

    
        
    

    
        
    



    

    
        
    

    

    

    



    

    
        
    

    

    



    




    



    


        
    

    

    
        
    const [value_tw2, setValue_tw2] = React.useState(0); 
    const handleChange_tw2 = (event, newValue) => { setValue_tw2(newValue); };
    
        
    
        
    
        
    
        
            

    

    

    
        
    



    


        
    
        
            

    

    

    
        
    



    


        
    
        
            

    

    

    
        
    



    


        
    
        
            

    

    

    
        
    



    


        
    
        
            

    

    

    
        
    



    


        
    
        
            

    

    

    
        
    



    


        
    

    

    
        
    const [value_tw3, setValue_tw3] = React.useState(0); 
    const handleChange_tw3 = (event, newValue) => { setValue_tw3(newValue); };
    
        
    
        
    
        
    
        
            

    

    

    
        
    

    

    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    



    


        
    
        
            

    

    

    
        
    

    

    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    



    


        
    
        
            

    

    

    
        
    

    

    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    

    
        
    

    
        
    



    




    



    


        
    

    


    const uiStateSlice = createSlice({
  name: 'uiState',
  initialState: { componentsState:{
    

    

    
        
    

    

    

    

    
        
    

    

    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    eng_con_capture_type_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    



    



    

    
        
    

    
        
    



    

    
        
    



    



    

    
        
    

    
        
    



    

    
        
    
    eng_con_sample_no_spin_box: 1,

    

    
        
    eng_con_sample_no_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    eng_con_clock_freq_spin_box: 1,

    

    
        
    eng_con_clock_freq_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    eng_con_input_freq_spin_box: 1,

    

    
        
    eng_con_input_freq_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    



    



    

    
        
    

    
        
    



    

    
        
    eng_con_coherence_checkbox: false,

    



    

    
        
    

    
        
    



    

    
        
    eng_con_ddc_config_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    eng_con_ddc_data_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    eng_con_ddc_decim_spin_box: 1,

    

    
        
    eng_con_ddc_decim_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    eng_con_mixer_freq_spin_box: 1,

    

    
        
    eng_con_mixer_freq_combo_box: 0,

    



    



    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    
    sig_src_freq_spin_box: 1,

    

    
        
    sig_src_freq_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    sig_src_amp_spin_box: 1,

    

    
        
    sig_src_amp_combo_box: 0,

    



    



    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    rm_hd_hd23_checkbox: false,

    



    

    
        
    

    
        
    



    

    
        
    rm_hd_hd5_checkbox: false,

    



    



    



    

    
        
    

    

    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    
    data_con_adc_res_spin_box: 1,

    

    
        
    data_con_adc_res_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    data_con_offset_spin_box: 1,

    

    
        
    data_con_offset_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    data_con_window_combo_box: 0,

    



    



    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    
    fft_con_fin_spin_box: 1,

    

    
        
    fft_con_fin_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    fft_con_fs_spin_box: 1,

    

    
        
    fft_con_fs_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    fft_con_full_scale_spin_box: 1,

    

    
        
    fft_con_full_scale_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    fft_con_harmonics_no_spin_box: 1,

    

    
        
    fft_con_harmonics_no_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    fft_con_dc_skip_bins_spin_box: 1,

    

    
        
    fft_con_dc_skip_bins_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    fft_con_fs_skip_bins_spin_box: 1,

    

    
        
    fft_con_fs_skip_bins_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    fft_con_fin_skip_bins_spin_box: 1,

    

    
        
    fft_con_fin_skip_bins_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    fft_con_snr_freq_band_lower_spin_box: 1,

    

    
        
    fft_con_snr_freq_band_lower_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    fft_con_snr_freq_band_upper_spin_box: 1,

    

    
        
    fft_con_snr_freq_band_upper_combo_box: 0,

    



    



    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    
    fft_plot_con_harmonics_no_spin_box: 1,

    

    
        
    fft_plot_con_harmonics_no_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    fft_plot_con_y_axis_scale_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    fft_plot_con_show_markers_checkbox: false,

    



    



    

    
        
    

    

    

    
        
    

    
        
    



    

    
        
    
    il_con_n_adc_spin_box: 1,

    

    
        
    il_con_n_adc_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    il_con_fs_spin_box: 1,

    

    
        
    il_con_fs_combo_box: 0,

    



    

    
        
    

    
        
    



    

    
        
    
    il_con_fin_spin_box: 1,

    

    
        
    il_con_fin_combo_box: 0,

    



    



    



    



    

    
        
    

    

    

    

    
        
    

    

    

    
        
    data_plot: {},

    



    

    
        
    

    

    

    
        
    inl_plot: {},

    



    

    
        
    

    

    

    
        
    inl_rise_fall_plot: {},

    



    

    
        
    

    

    

    
        
    fft_plot: {},

    



    

    
        
    

    

    

    
        
    complex_data_plot: {},

    



    

    
        
    

    

    

    
        
    complex_fft_plot: {},

    



    



    

    
        
    

    

    

    

    
        
    

    

    

    
        
    

    

    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    



    



    

    
        
    

    

    

    
        
    

    

    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    



    



    

    
        
    

    

    

    
        
    

    

    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    

    
        
    

    
        
    



    



    



    



    



    


}
  },
  reducers: {
    setComponentsState(state, action) { state.componentsState = action.payload },
    setComponentValue(state, action) {
      const { id, value } = action.payload || {};
      if (!state.componentsState) state.componentsState = {};
      state.componentsState[id] = value;
    },
  },
});

const store = React.useMemo(() => configureStore({
  reducer: { uiState: uiStateSlice.reducer }
}), []);

const wsUrl = serverUrl.replace(/^https?:/, m => m === 'https:' ? 'wss:' : 'ws:');
const api = axios.create({ baseURL: serverUrl });

  const [handlerIds, setHandlerIds] = useState(new Set());

  const handleEvents = (id) => {
    try {
      const currentState = store.getState();
      api.post(`/changed/${id}`, { uiState: currentState.uiState.componentsState })
        .then((response) => {
          if (response.data && typeof response.data === 'object') {
            try {
              store.dispatch(uiStateSlice.actions.setComponentsState(response.data));
            } catch (err) {
              console.error('failed to dispatch updated state', err);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (err) {
      console.error('failed to read store state', err);
    }
  };

  const normalizeId = (raw) => {
    if (raw == null) return '';
    let s = String(raw);
    // strip leading dashes
    s = s.replace(/^-+/, '');
    // trim, lower-case
    s = s.trim().toLowerCase();
    // replace whitespace with underscore
    s = s.replace(/\s+/g, '_');
    // replace non-alphanumeric/underscore with underscore
    s = s.replace(/[^a-z0-9_]/g, '_');
    // collapse multiple underscores
    s = s.replace(/_+/g, '_');
    // strip leading/trailing underscores
    s = s.replace(/^_+|_+$/g, '');
    return s;
  };

  const handleLoadEvents = (id) => {
    try {
      const currentState = store.getState();
      api
        .post(`/loaded/${id}`, {
          uiState: currentState.uiState.componentsState,
        })
        .then((response) => {
          if (response.data && typeof response.data === "object") {
            try {
              store.dispatch(
                uiStateSlice.actions.setComponentsState(response.data),
              );
            } catch (err) {
              console.error("failed to dispatch updated state", err);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (err) {
      console.error("failed to read store state", err);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initFromServer = useCallback(() => {
    api.get('/ids')
      .then((response) => {
        const ids = (response.data || []).map((x) => normalizeId(x));
        setHandlerIds(new Set(ids));
      })
      .catch((error) => { console.error('GET /ids failed:', error); });
    api.get('/loaded_ids')
      .then((response) => {
        (response.data || []).map((x) => handleLoadEvents(normalizeId(x)));
      })
      .catch((error) => { console.error('GET /loaded_ids failed:', error); });
  }, [serverUrl]); // eslint-disable-line

  useEffect(() => {
    if (!serverUrl) return;
    let ws;
    let retryTimer;
    let destroyed = false;

    const connect = () => {
      ws = new WebSocket(wsUrl + '/ws');
      ws.onopen = () => {
        console.log('Bridge WebSocket connected');
        initFromServer();
      };
      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          store.dispatch(uiStateSlice.actions.setComponentsState(data));
        } catch (err) {
          console.error('WebSocket message parse error', err);
        }
      };
      ws.onclose = () => {
        if (!destroyed) {
          console.log('Bridge WebSocket closed — retrying in 3s');
          retryTimer = setTimeout(connect, 3000);
        }
      };
      ws.onerror = () => {};  // onclose fires after onerror, handles retry
    };

    connect();
    return () => {
      destroyed = true;
      clearTimeout(retryTimer);
      ws && ws.close();
    };
  }, [serverUrl]);

const ConnectedLinearProgress = connect((state, ownProps) => ({
    value: (state.uiState?.componentsState?.[ownProps.id] ?? 0)
  }))(({ id, value, ...props }) => <LinearProgress id={id} variant="determinate" value={value} {...props} />);

const ConnectedLabel = connect((state, ownProps) => ({
    text: (() => {
      const cs = state.uiState?.componentsState;
      var text = cs?.[ownProps.id] ?? '';
      return text;
    })(),
  }))(({ id, text, variant, style }) => (
    <Typography id={id} variant={variant} style={style}>
      {text}
    </Typography>
  ));

const ConnectedTextarea = connect((state, ownProps) => ({
    value: state.uiState?.componentsState?.[ownProps.id] ?? '',
  }))(({ id, value, dispatch, ...props }) => (
    <TextField
      {...props}
      id={id}
      value={value}
      onChange={(e) => {
        const v = e.target.value;
        dispatch(uiStateSlice.actions.setComponentValue({ id, value: v }));
        if (handlerIds.has(id)) handleEvents(id);
      }}
    />
  ));

const ConnectedAutocomplete = connect((state, ownProps) => ({
    selectedIndex: state.uiState?.componentsState?.[ownProps.id] ?? null,
  }))(({ id, selectedIndex, dispatch, options = [], ...props }) => {
    const value = typeof selectedIndex === 'number' ? options[selectedIndex] ?? null : null;
    return (
      <Autocomplete
        {...props}
        id={id}
        value={value}
        onChange={(e, v) => {
          const idx = options.findIndex((o) => o === v || o.label === v?.label);
          dispatch(uiStateSlice.actions.setComponentValue({ id, value: idx }));
          if (handlerIds.has(id)) handleEvents(id);
        }}
        options={options}
      />
    );
  });

const ConnectedLineEdit = connect((state, ownProps) => ({
    value: state.uiState?.componentsState?.[ownProps.id] ?? '',
  }))(({ id, value, dispatch, ...props }) => (
    <TextField
      {...props}
      id={id}
      value={value}
      onChange={(e) => {
        const v = e.target.value;
        dispatch(uiStateSlice.actions.setComponentValue({ id, value: v }));
        if (handlerIds.has(id)) handleEvents(id);
      }}
    />
  ));

  const ConnectedNumberField = connect((state, ownProps) => ({
    value: state.uiState?.componentsState?.[ownProps.id] ?? null,
  }))(({ id, value, dispatch, onFormControlClick, ...props }) => (
    <NumberField
      {...props}
      id={id}
      // try to provide the current value as defaultValue if available
      defaultValue={value}
      onFormControlClick={(v) => {
        // v may be string; coerce to number when possible
        const num = v === '' || v == null ? '' : Number(v);
        dispatch(uiStateSlice.actions.setComponentValue({ id, value: num }));
        if (handlerIds.has(id)) handleEvents(id);
        if (typeof onFormControlClick === 'function') onFormControlClick(v);
      }}
    />
  ));

const ConnectedCheckbox = connect((state, ownProps) => ({
    checked: !!state.uiState?.componentsState?.[ownProps.id],
  }))(({ id, checked, dispatch, label, ...props }) => (
    <FormControlLabel
      control={<Checkbox checked={checked} {...props} onChange={(e) => {
        const v = e.target.checked;
        dispatch(uiStateSlice.actions.setComponentValue({ id, value: v }));
        if (handlerIds.has(id)) handleEvents(id);
      }} />}
      label={label}
    />
  ));

 const ConnectedStack = connect((state, ownProps) => ({
    activeIndex: state.uiState?.componentsState?.[ownProps.id] ?? 0,
  }))(({ id, activeIndex, children }) => {
    const pages = React.Children.toArray(children || []);
    // build base name for page ids by stripping underscores so it matches
    // earlier id conventions like `sw1_0_visible`.
    const base = String(id || '').replace(/_/g, '');
    return (
      <div>
        {pages.map((child, idx) => (
          <div key={idx} id={`${base}_${idx}_${activeIndex === idx ? 'visible' : 'hidden'}`}>
            {child}
          </div>
        ))}
      </div>
    );
  });

const ConnectedPlot = connect((state, ownProps) => ({
    plotData: (state.uiState?.componentsState?.[ownProps.id] ?? null),
  }))(({ id, plotData, ...props }) => {
  
    const traces = Object.entries(plotData).map(([sampleName, data]) => ({
  x: data.x,
  y: data.y,
  type: "scatter",
  mode: "lines",
  name: sampleName,
}));

return(
  
    <Box sx={ { width: '100%', height: 260, mt: 2 } }>
    <ConnectedLineChart id = {id} data={traces}></ConnectedLineChart>
    </Box>
  
     );
  });

const ConnectedRadioGroup = connect((state, ownProps) => {
    const cs = state.uiState?.componentsState || {};
    // Prefer explicit group selected value (string). If not set, fall back to per-radio booleans
    const sel = cs[ownProps.id];
    if (typeof sel === 'string' && sel) {
      return { selectedId: sel };
    }
    // derive members from ownProps children (may be FormControlLabel/Radio elements)
    const members = React.Children.toArray(ownProps.children).map((c) => c?.props?.value).filter(Boolean);
    const found = members.find((m) => Boolean(cs[m]));
    return { selectedId: found ?? '' };
  })(({ id: groupId, selectedId, dispatch, children, ...props }) => {
    const members = React.Children.toArray(children)
      .map((c) => c?.props?.value)
      .filter(Boolean);

    const handleChange = (e, value) => {
      // user selected a radio; set selectedId for this group and update booleans
      dispatch(uiStateSlice.actions.setComponentValue({ id: groupId, value }));
      members.forEach((m) =>
        dispatch(
          uiStateSlice.actions.setComponentValue({ id: m, value: m === value })
        )
      );
      // notify backend for selected group and peers
      if (handlerIds.has(groupId)) handleEvents(groupId);
      members.forEach((m) => {
        if (handlerIds.has(m)) handleEvents(m);
      });
    };

    // Clone children to add click behavior: clicking the already-selected radio
    // will toggle it off (set selectedId to empty and all booleans false).
    const cloned = React.Children.map(children, (child) => {
      if (!React.isValidElement(child)) return child;
      const childValue = child.props.value;
      const onClick = (e) => {
        if (childValue === selectedId) {
          // toggle off for this group
          dispatch(
            uiStateSlice.actions.setComponentValue({ id: groupId, value: "" })
          );
          members.forEach((m) =>
            dispatch(
              uiStateSlice.actions.setComponentValue({ id: m, value: false })
            )
          );
          if (handlerIds.has(groupId)) handleEvents(groupId);
          members.forEach((m) => {
            if (handlerIds.has(m)) handleEvents(m);
          });
          // prevent RadioGroup default behavior
          e.preventDefault();
        }
      };
      return React.cloneElement(child, { onClick });
    });

    return (
      <RadioGroup value={selectedId || ""} onChange={handleChange} {...props}>
        {cloned}
      </RadioGroup>
    );
  });

    return (
        <Provider store={store}>
        <ThemeProvider theme={TIRedTheme}>
      <CssBaseline />
        <div className="app-root">
        
















            <div className="layout row root_div">
                
                








<Box style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    <Box>
        <Tabs value={value_tw1} onChange={handleChange_tw1} aria-label="basic tabs example" >
        
            
                
            
                
            
                
            
                
                    <Tab label="Wave Setup" />
                
            
                
                    <Tab label="Process Controls" />
                
            
        </Tabs>
    </Box>
    
    
        
    
        
    
        
    
        
            <CustomTabPanel value={value_tw1} index={ 0 }>
                <div className="layout column stretch">
                    










<div className="layout column stretch" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    Engine Controls
    <div className="layout  column stretch">
        













    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_capture_type" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='eng_con_capture_type_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      capture_type
    </div>












    <ConnectedAutocomplete id="eng_con_capture_type_combo_box"
    options={[
    
    {"label":"Finite samples" },
    
    {"label":" Continuous" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_start_button" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='_eng_row_start_button_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      start_button
    </div>






     
<Button id='eng_row_start_button' onClick={handlerIds.has('eng_row_start_button') ? () => handleEvents('eng_row_start_button') : undefined} variant="contained" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }> Start Capture </Button> 










    </div>















    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_stop_button" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='eng_con_stop_button_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      stop_button
    </div>






     
<Button id='eng_con_stop_button_button' onClick={handlerIds.has('eng_con_stop_button_button') ? () => handleEvents('eng_con_stop_button_button') : undefined} variant="contained" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }> Stop Capture </Button> 










    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_sample_no" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='eng_con_sample_no_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      sample_no
    </div>












    
    <ConnectedNumberField id = 'eng_con_sample_no_spin_box' min={ 1 } max={  100 } step={  0.01 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="eng_con_sample_no_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_clock_freq" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='eng_con_clock_freq_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      clock_frequency
    </div>












    
    <ConnectedNumberField id = 'eng_con_clock_freq_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="eng_con_clock_freq_combo_box"
    options={[
    
    {"label":"nHz" },
    
    {"label":" uHz" },
    
    {"label":" mHz" },
    
    {"label":" Hz" },
    
    {"label":" kHz" },
    
    {"label":" MHz" },
    
    {"label":" GHz" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_input_freq" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='eng_con_input_freq_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      input_frequency
    </div>












    
    <ConnectedNumberField id = 'eng_con_input_freq_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="eng_con_input_freq_combo_box"
    options={[
    
    {"label":"nHz" },
    
    {"label":" uHz" },
    
    {"label":" mHz" },
    
    {"label":" Hz" },
    
    {"label":" kHz" },
    
    {"label":" MHz" },
    
    {"label":" GHz" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_set_coherence" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='eng_con_set_coherence_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      set_coherence
    </div>






     
<Button id='eng_con_set_coherence_button' onClick={handlerIds.has('eng_con_set_coherence_button') ? () => handleEvents('eng_con_set_coherence_button') : undefined} variant="contained" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }> Set Coherence </Button> 










    </div>















    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_coherence" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='eng_con_coherence_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      coherence
    </div>







<ConnectedCheckbox 
    id='eng_con_coherence_checkbox'
    label='Coherence'
    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }
/>











    </div>















    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_ddc_config" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='eng_con_ddc_config_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      ddc_config
    </div>












    <ConnectedAutocomplete id="eng_con_ddc_config_combo_box"
    options={[
    
    {"label":"DDC Bypassed" },
    
    {"label":" DDC Enabled" },
    
    {"label":" DDC Enabled Complex" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_ddc_data" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='eng_con_ddc_data_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      ddc_data
    </div>












    <ConnectedAutocomplete id="eng_con_ddc_data_combo_box"
    options={[
    
    {"label":"RF Sampling" },
    
    {"label":" IF Sampling" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_ddc_decim" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='eng_con_ddc_decim_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      ddc_decim
    </div>












    
    <ConnectedNumberField id = 'eng_con_ddc_decim_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="eng_con_ddc_decim_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-eng_con_mixer_freq" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='eng_con_mixer_freq_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      mixer_freq
    </div>












    
    <ConnectedNumberField id = 'eng_con_mixer_freq_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="eng_con_mixer_freq_combo_box"
    options={[
    
    {"label":"nHz" },
    
    {"label":" uHz" },
    
    {"label":" mHz" },
    
    {"label":" Hz" },
    
    {"label":" kHz" },
    
    {"label":" MHz" },
    
    {"label":" GHz" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>








    </div>
</div>












<div className="layout column stretch" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    Signal Source
    <div className="layout  column stretch">
        













    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-sig_src_freq" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='sig_src_freq_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      frequency
    </div>












    
    <ConnectedNumberField id = 'sig_src_freq_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="sig_src_freq_combo_box"
    options={[
    
    {"label":"nHz" },
    
    {"label":" uHz" },
    
    {"label":" mHz" },
    
    {"label":" Hz" },
    
    {"label":" kHz" },
    
    {"label":" MHz" },
    
    {"label":" GHz" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-sig_src_amp" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='sig_src_amp_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      amplitude
    </div>












    
    <ConnectedNumberField id = 'sig_src_amp_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="sig_src_amp_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>








    </div>
</div>












<div className="layout column stretch" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    Remove HD
    <div className="layout  column stretch">
        













    
        
    
        
    



    <div className="layout row stretch" id="container-rm_hd_hd23" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='rm_hd_hd23_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      en_remove_hd2_hd3
    </div>







<ConnectedCheckbox 
    id='rm_hd_hd23_checkbox'
    label='Remove hd2, hd3'
    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }
/>











    </div>















    
        
    
        
    



    <div className="layout row stretch" id="container-rm_hd_hd5" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='rm_hd_hd5_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      en_remove_hd2_hd3
    </div>







<ConnectedCheckbox 
    id='rm_hd_hd5_checkbox'
    label='Remove hd5'
    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }
/>











    </div>








    </div>
</div>








                </div>
            </CustomTabPanel>
        
        
    
        
            <CustomTabPanel value={value_tw1} index={ 1 }>
                <div className="layout column stretch">
                    










<div className="layout column stretch" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    Data Controls
    <div className="layout  column stretch">
        













    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-data_con_adc_res" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='data_con_adc_res_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      adc_res
    </div>












    
    <ConnectedNumberField id = 'data_con_adc_res_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="data_con_adc_res_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-data_con_offset" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='data_con_offset_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      offset
    </div>












    
    <ConnectedNumberField id = 'data_con_offset_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="data_con_offset_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    



    <div className="layout row stretch" id="container-data_con_window" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='data_con_window_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      window
    </div>












    <ConnectedAutocomplete id="data_con_window_combo_box"
    options={[
    
    {"label":"Blackmann" },
    
    {"label":" Hamming" },
    
    {"label":" Hanning" },
    
    {"label":" Rectangular" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>








    </div>
</div>












<div className="layout column stretch" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    FFT Controls
    <div className="layout  column stretch">
        













    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-fft_con_fin" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_con_fin_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      fin
    </div>












    
    <ConnectedNumberField id = 'fft_con_fin_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="fft_con_fin_combo_box"
    options={[
    
    {"label":"nHz" },
    
    {"label":" uHz" },
    
    {"label":" mHz" },
    
    {"label":" Hz" },
    
    {"label":" kHz" },
    
    {"label":" MHz" },
    
    {"label":" GHz" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-fft_con_fs" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_con_fs_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      fs
    </div>












    
    <ConnectedNumberField id = 'fft_con_fs_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="fft_con_fs_combo_box"
    options={[
    
    {"label":"nHz" },
    
    {"label":" uHz" },
    
    {"label":" mHz" },
    
    {"label":" Hz" },
    
    {"label":" kHz" },
    
    {"label":" MHz" },
    
    {"label":" GHz" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-fft_con_full_scale" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_con_full_scale_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      full scale
    </div>












    
    <ConnectedNumberField id = 'fft_con_full_scale_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="fft_con_full_scale_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-fft_con_harmonics_no" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_con_harmonics_no_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      harmonics_no
    </div>












    
    <ConnectedNumberField id = 'fft_con_harmonics_no_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="fft_con_harmonics_no_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-fft_con_dc_skip_bins" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_con_dc_skip_bins_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      dc_skip_bins
    </div>












    
    <ConnectedNumberField id = 'fft_con_dc_skip_bins_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="fft_con_dc_skip_bins_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-fft_con_fs_skip_bins" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_con_fs_skip_bins_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      fs_skip_bins
    </div>












    
    <ConnectedNumberField id = 'fft_con_fs_skip_bins_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="fft_con_fs_skip_bins_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-fft_con_fin_skip_bins" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_con_fin_skip_bins_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      fin_skip_bins
    </div>












    
    <ConnectedNumberField id = 'fft_con_fin_skip_bins_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="fft_con_fin_skip_bins_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-fft_con_snr_freq_band_lower" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_con_snr_freq_band_lower_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      snr_freq_band_lower
    </div>












    
    <ConnectedNumberField id = 'fft_con_snr_freq_band_lower_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="fft_con_snr_freq_band_lower_combo_box"
    options={[
    
    {"label":"nHz" },
    
    {"label":" uHz" },
    
    {"label":" mHz" },
    
    {"label":" Hz" },
    
    {"label":" kHz" },
    
    {"label":" MHz" },
    
    {"label":" GHz" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-fft_con_snr_freq_band_upper" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_con_snr_freq_band_upper_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      snr_freq_band_upper
    </div>












    
    <ConnectedNumberField id = 'fft_con_snr_freq_band_upper_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="fft_con_snr_freq_band_upper_combo_box"
    options={[
    
    {"label":"nHz" },
    
    {"label":" uHz" },
    
    {"label":" mHz" },
    
    {"label":" Hz" },
    
    {"label":" kHz" },
    
    {"label":" MHz" },
    
    {"label":" GHz" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>








    </div>
</div>












<div className="layout column stretch" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    FFT Plot Controls
    <div className="layout  column stretch">
        













    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-fft_plot_con_harmonics_no" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_plot_con_harmonics_no_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      harmonics_no
    </div>












    
    <ConnectedNumberField id = 'fft_plot_con_harmonics_no_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="fft_plot_con_harmonics_no_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    



    <div className="layout row stretch" id="container-fft_plot_con_y_axis_scale" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_plot_con_y_axis_scale_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      y_axis_scale
    </div>












    <ConnectedAutocomplete id="fft_plot_con_y_axis_scale_combo_box"
    options={[
    
    {"label":"Linear" },
    
    {"label":" Log" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    



    <div className="layout row stretch" id="container-fft_plot_con_show_marker" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_plot_con_show_markers_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      show_markers
    </div>







<ConnectedCheckbox 
    id='fft_plot_con_show_markers_checkbox'
    label='Show Markers'
    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }
/>











    </div>








    </div>
</div>












<div className="layout column stretch" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    IL Controls
    <div className="layout  column stretch">
        













    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-il_con_n_adc" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='il_con_n_adc_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      n_adc
    </div>












    
    <ConnectedNumberField id = 'il_con_n_adc_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="il_con_n_adc_combo_box"
    options={[
    
    {"label":"n" },
    
    {"label":" u" },
    
    {"label":" m" },
    
    {"label":"&nbsp; " },
    
    {"label":" k" },
    
    {"label":" M" },
    
    {"label":" G&nbsp;&nbsp;" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-il_con_fs" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='il_con_fs_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      fs
    </div>












    
    <ConnectedNumberField id = 'il_con_fs_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="il_con_fs_combo_box"
    options={[
    
    {"label":"nHz" },
    
    {"label":" uHz" },
    
    {"label":" mHz" },
    
    {"label":" Hz" },
    
    {"label":" kHz" },
    
    {"label":" MHz" },
    
    {"label":" GHz" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>















    
        
    
        
    
        
    



    <div className="layout row stretch" id="container-il_con_fin" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='il_con_fin_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      fin
    </div>












    
    <ConnectedNumberField id = 'il_con_fin_spin_box' min={ 1 } max={  10 } step={  0.5 } style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '150px', maxWidth: '150px', width: '150px', flexShrink: 0 } }/>











    <ConnectedAutocomplete id="il_con_fin_combo_box"
    options={[
    
    {"label":"nHz" },
    
    {"label":" uHz" },
    
    {"label":" mHz" },
    
    {"label":" Hz" },
    
    {"label":" kHz" },
    
    {"label":" MHz" },
    
    {"label":" GHz" },
    
    ]}
    renderInput={(params) => <TextField {...params} label="" placeholder="Select option" />}

    style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: '180px', maxWidth: '180px', width: '180px', flexShrink: 0 } }/>





    </div>








    </div>
</div>








                </div>
            </CustomTabPanel>
        
        
    
</Box>












<Box style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    <Box>
        <Tabs value={value_tw2} onChange={handleChange_tw2} aria-label="basic tabs example" >
        
            
                
            
                
            
                
            
                
                    <Tab label="Data Plot" />
                
            
                
                    <Tab label="INL Plot" />
                
            
                
                    <Tab label="INL Rise Fall Plot" />
                
            
                
                    <Tab label="FFT Plot" />
                
            
                
                    <Tab label="Complex Data Plot" />
                
            
                
                    <Tab label="Complex FFT Plot" />
                
            
        </Tabs>
    </Box>
    
    
        
    
        
    
        
    
        
            <CustomTabPanel value={value_tw2} index={ 0 }>
                <div className="layout column stretch">
                    











<ConnectedPlot id="data_plot"></ConnectedPlot>






                </div>
            </CustomTabPanel>
        
        
    
        
            <CustomTabPanel value={value_tw2} index={ 1 }>
                <div className="layout column stretch">
                    











<ConnectedPlot id="inl_plot"></ConnectedPlot>






                </div>
            </CustomTabPanel>
        
        
    
        
            <CustomTabPanel value={value_tw2} index={ 2 }>
                <div className="layout column stretch">
                    











<ConnectedPlot id="inl_rise_fall_plot"></ConnectedPlot>






                </div>
            </CustomTabPanel>
        
        
    
        
            <CustomTabPanel value={value_tw2} index={ 3 }>
                <div className="layout column stretch">
                    











<ConnectedPlot id="fft_plot"></ConnectedPlot>






                </div>
            </CustomTabPanel>
        
        
    
        
            <CustomTabPanel value={value_tw2} index={ 4 }>
                <div className="layout column stretch">
                    











<ConnectedPlot id="complex_data_plot"></ConnectedPlot>






                </div>
            </CustomTabPanel>
        
        
    
        
            <CustomTabPanel value={value_tw2} index={ 5 }>
                <div className="layout column stretch">
                    











<ConnectedPlot id="complex_fft_plot"></ConnectedPlot>






                </div>
            </CustomTabPanel>
        
        
    
</Box>












<Box style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    <Box>
        <Tabs value={value_tw3} onChange={handleChange_tw3} aria-label="basic tabs example" >
        
            
                
            
                
            
                
            
                
                    <Tab label="Data Params" />
                
            
                
                    <Tab label="FFT Params" />
                
            
                
                    <Tab label="Complex FFT Params" />
                
            
        </Tabs>
    </Box>
    
    
        
    
        
    
        
    
        
            <CustomTabPanel value={value_tw3} index={ 0 }>
                <div className="layout column stretch">
                    










<div className="layout column stretch" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    Data Info
    <div className="layout  column stretch">
        













    
        
    



    <div className="layout row stretch" id="container-data_info_mid_code_data" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='data_info_mid_code_data_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      mid_code_data
    </div>
    <ConnectedLabel id='data_param_mid_code_data' variant="body2" style={{padding:'8px 12px', fontSize:'13px', color:'#1565c0', fontWeight:'600'}} />






    </div>















    
        
    



    <div className="layout row stretch" id="container-data_info_range_data" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='data_info_range_data_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      range_data
    </div>
    <ConnectedLabel id='data_param_range_data' variant="body2" style={{padding:'8px 12px', fontSize:'13px', color:'#1565c0', fontWeight:'600'}} />






    </div>















    
        
    



    <div className="layout row stretch" id="container-data_info_max_data" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='data_info_max_data_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      max_data
    </div>
    <ConnectedLabel id='data_param_max_data' variant="body2" style={{padding:'8px 12px', fontSize:'13px', color:'#1565c0', fontWeight:'600'}} />






    </div>















    
        
    



    <div className="layout row stretch" id="container-data_info_min_data" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='data_info_min_data_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      min_data
    </div>
    <ConnectedLabel id='data_param_min_data' variant="body2" style={{padding:'8px 12px', fontSize:'13px', color:'#1565c0', fontWeight:'600'}} />






    </div>








    </div>
</div>








                </div>
            </CustomTabPanel>
        
        
    
        
            <CustomTabPanel value={value_tw3} index={ 1 }>
                <div className="layout column stretch">
                    










<div className="layout column stretch" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    FFT Info
    <div className="layout  column stretch">
        













    
        
    



    <div className="layout row stretch" id="container-fft_info_fund_ampl" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='fft_info_fund_ampl_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      fund_ampl
    </div>
    <ConnectedLabel id='fft_param_fund_ampl' variant="body2" style={{padding:'8px 12px', fontSize:'13px', color:'#1565c0', fontWeight:'600'}} />






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_492" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_493' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      spur_freq
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_494" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_495' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      spur_dB
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_496" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_497' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      in_band_snr
    </div>
    <ConnectedLabel id='fft_param_in_band_snr' variant="body2" style={{padding:'8px 12px', fontSize:'13px', color:'#1565c0', fontWeight:'600'}} />






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_498" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_499' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      in_band_sinad
    </div>
    <ConnectedLabel id='fft_param_in_band_sinad' variant="body2" style={{padding:'8px 12px', fontSize:'13px', color:'#1565c0', fontWeight:'600'}} />






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_500" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_501' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      in_band_sfdr
    </div>
    <ConnectedLabel id='fft_param_in_band_sfdr' variant="body2" style={{padding:'8px 12px', fontSize:'13px', color:'#1565c0', fontWeight:'600'}} />






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_505" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_506' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      in_band_thd
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_507" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_508' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H2
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_509" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_510' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H3
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_511" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_512' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H4
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_513" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_514' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H5
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_515" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_516' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H6
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_517" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_518' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H7
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_519" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_520' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H8
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_521" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_522' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H9
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_523" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_524' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      full_band_snr
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_525" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_526' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      full_band_sinad
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_527" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_528' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      full_band_thd
    </div>






    </div>








    </div>
</div>








                </div>
            </CustomTabPanel>
        
        
    
        
            <CustomTabPanel value={value_tw3} index={ 2 }>
                <div className="layout column stretch">
                    










<div className="layout column stretch" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
    Complex FFT Info
    <div className="layout  column stretch">
        













    
        
    



    <div className="layout row stretch" id="container-complex_fft_info_fund_ampl" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='complex_fft_info_fund_ampl_label' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      fund_ampl
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_531" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_532' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      dc_offset
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_533" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_534' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      fund_image_ampl
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_535" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_536' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      spur_freq
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_537" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_538' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      spur_dB
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_539" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_540' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      spur_freq_emission
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_542" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_543' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      in_band_snr
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_544" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_545' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      in_band_sinad
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_546" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_547' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      in_band_sfdr
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_548" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_549' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      in_band_thd
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_550" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_551' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H2
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_552" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_553' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H3
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_554" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_555' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H4
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_556" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_557' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H5
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_558" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_559' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H6
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_560" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_561' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H7
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_562" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_563' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H8
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_564" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_565' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H9
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_566" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_567' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      H10
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_568" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_569' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      full_band_snr
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_570" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_571' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      full_band_sinad
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_572" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_573' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      full_band_thd
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_574" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_575' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      ddc_band_snr
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_576" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_577' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      ddc_band_sinad
    </div>






    </div>















    
        
    



    <div className="layout row stretch" id="container-uQ084gRTIuPxBBYMIQaJ_578" style= { { minHeight: 'vh', maxHeight: 'vh', minWidth: 'vw', maxWidth: 'vw' } }>
        







    <div id='uQ084gRTIuPxBBYMIQaJ_579' style={ {
      minHeight: 'vh',
      maxHeight: 'vh',
      minWidth: '120px',
      maxWidth: '120px',
      width: '120px',
      padding: '8px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      flexShrink: 0
    } }>
      ddc_band_thd
    </div>






    </div>








    </div>
</div>








                </div>
            </CustomTabPanel>
        
        
    
</Box>









            </div>
        </div>
        </ThemeProvider>
        </Provider>
    );
};

export default App;